<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2019-12-06 14:45:50
 * @LastEditTime: 2020-03-05 11:26:25
 -->
<template>
  <div
    style="width: 100%; height: 100%"
    @contextmenu.prevent
  >
    <!-- icon 所有的图标 -->
    <co-icon v-show="false" />
    <co-toast
      v-model="toastInfo.switch"
      :toast-info="toastInfo.content"
    />
    <router-view ref="view" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import store from 'store'
import Cookie from 'js/lib/cookie.js'
import * as Util from 'js/util/util'
import coIcon from 'components/common/icon/index.vue'
import coToast from 'components/common/toast/index.vue'
import _$ from 'js/api/getdata.js'
import ClientMethod from 'js/client-method/index'


export default {
  methods: {
    ...mapActions(['getLenData', 'getLanguage', 'getUserInfo', 'getAccountInfo', 'getCname']),
    getPublicKey() {
      return _$.getData('getPublicKey')
    },
    /**
             * 是否为外链
             */
    isLink() {
      const linkList = [
        '^/v/link/',
        '^/v/thirdparty/',
        '^/v/icondict/',
      ]
      const { pathname } = window.location
      for (let i = 0; i < linkList.length; ++i) {
        const item = linkList[i]
        const patt = new RegExp(item)
        if (patt.test(pathname)) {
          return true
        }
      }
      return false
    },
    /**
             * 设置title
             */
    setTitle() {
      const customizeSetting = store.getters.custominfo
      const { language } = store.state.lenovoData
      const pageIcon = customizeSetting.page_icon
      const customsizeTitle = language === 'zh' ? customizeSetting.custom_product_zh_name : customizeSetting.custom_product_en_name
      document.title = customsizeTitle || this.$t('联想企业网盘')
      if (pageIcon) {
        const linkEle = document.getElementById('link-icon')
        linkEle.href = pageIcon
        linkEle.type = ''
        linkEle.type = 'image/x-icon'
      }
    },
    /**
     * 初始化函数
     */
    init() {
      const me = this
      const il = this.isLink()
      const callBack = function () {
        Util.loadCssCode(Util.getButtonPrimaryCssCode()) // 接口返回数据之后插入设置的主题色，来覆盖原来的主题色
        me.setTitle()
        if (Util.isClient()) {
          new ClientMethod(this)
        }
      }
      if (il) {
        // 去掉登录拦截
        _$.removeResInter()
        Promise.all([this.getLenData(), this.getUserInfo(), this.getLanguage()])
          .then(() => {
            me.setTitle()
            Util.loadCssCode(Util.getButtonPrimaryCssCode())
          })
          .catch((err) => {
            console.log('some error happens:', err)
          })
      } else {
        Promise.all([this.getLenData(), this.getUserInfo(), this.getAccountInfo(), this.getLanguage()])
          .then(() => { callBack() })
      }
    },
  },
  components: {
    coIcon,
    coToast,
  },
  data() {
    return {
    }
  },
  computed: {
    /**
             * 全局的toast提示
             */
    toastInfo() {
      return this.$store.state.toastInfo
    },
  },
  mounted() {
    this.getPublicKey().then((res) => {
      this.$jsEncrypt.setPublicKey(res.data.public_key)
    })
  },
  created() {
    this.init()
  },
}
</script>
